import { render, staticRenderFns } from "./Tournaments.vue?vue&type=template&id=c2d2e048&scoped=true&"
import script from "./Tournaments.vue?vue&type=script&lang=js&"
export * from "./Tournaments.vue?vue&type=script&lang=js&"
import style0 from "./Tournaments.vue?vue&type=style&index=0&id=c2d2e048&scoped=true&lang=css&"
import style1 from "./Tournaments.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d2e048",
  null
  
)

export default component.exports